import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { TextbausteineFormEngine } from "./components/customTextbausteineForm";
import { moveTextbausteinMiddleware } from "./middleware/moveTextbausteinMiddleware";
import { setTextbausteinFormReadonlyMiddleware } from "./middleware/setTextbausteinFormReadonlyMiddleware";
import { exportTextbausteineSaga } from "./sagas/exportTextbausteinSaga";
import { importTextbausteineSaga } from "./sagas/importTextbausteinSaga";
import { setCorrelatedFachverfahrenKeySaga } from "./sagas/setCorrelatedFachverfahrenKeySaga";
import { CustomTextbausteineTreeEngine } from "./components/CustomTextbausteineTreeEngine";
import { reloadOnFilterChangeSaga } from "./sagas/reloadOnFilterChangeSaga";

const textbausteineModule = (): Module => ({
	id: "textbausteineModule",
	views: () => viewComponentProvider,
	sagas: () => [
		setCorrelatedFachverfahrenKeySaga,
		exportTextbausteineSaga,
		importTextbausteineSaga,
		reloadOnFilterChangeSaga
	],
	middlewares: () => [setTextbausteinFormReadonlyMiddleware, moveTextbausteinMiddleware]
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	TextbausteineFormEngine,
	CustomTextbausteineTreeEngine
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default textbausteineModule;
